import React from 'react';

export default function GlassInput({ label, as = 'input', ...rest }) {
  const Tag = as; // 'input' | 'textarea' | 'select'
  return (
    <label className="glass-field">
      {label}
      <Tag className="glass-input" {...rest} />
    </label>
  );
}